import WorkspacesTable from "./WorkspacesTable";

export default function Workspaces(props) {
  const { onWorkspaceClick, workspaces, loading, users } = props;

  if (loading) {
    return null;
  }

  if (!Boolean(workspaces.length)) {
    return null;
  }

  return (
    <WorkspacesTable
      workspaces={workspaces}
      onWorkspaceClick={onWorkspaceClick}
      users={users}
    />
  );
}
